import { render, staticRenderFns } from "./VehicleOffers.vue?vue&type=template&id=48553150&"
import script from "./VehicleOffers.vue?vue&type=script&lang=js&"
export * from "./VehicleOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports